import { getConfig } from "~/org/twilio/one-support-center/shared/osc-env";

const { supportApiEndpoint } = getConfig();

const routes = {
  liveChat: "/live-chats",
  surveys: "/surveys",
};

export const helpCenterEndpoints = {
  createLiveChat: (): string => `${routes.liveChat}`,
  refreshLiveChatToken: (): string => `${routes.liveChat}/refreshToken`,
  getLiveChatMessages: (liveChatId: string): string =>
    `${routes.liveChat}/${liveChatId}`,
  endLiveChat: (liveChatId: string): string =>
    `${routes.liveChat}/${liveChatId}/end`,
  createSurveySession: (surveyId: string): string =>
    `${routes.surveys}/${surveyId}/sessions`,
  updateSurveySession: (surveyId: string, sessionId: string): string =>
    `${routes.surveys}/${surveyId}/sessions/${sessionId}`,
};

export const getHelpCenterApiServiceEndpoint = () => {
  const isLocal =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes(".local.");
  return isLocal
    ? "http://localhost:17825/v1"
    : `${supportApiEndpoint}/helpCenter`;
};
